// extracted by mini-css-extract-plugin
module.exports = {"header":"ShareButtons-module__header___1CUax","buttons":"ShareButtons-module__buttons___1O24g"};